import { FantasyPlayer } from "../../models/FantasyPlayer";
import { FantasyStartTeam } from "../../models/FantasyStartTeam";
import PlayerSlotV2 from "./PlayerSlotV2";
import styles from './PlayerSlotV2.module.css';

interface TeamSlotV2Props {
    team: FantasyStartTeam;
    onPlayerAddClick: (player: FantasyPlayer) => void;
    selectedPlayers?: FantasyPlayer[];
}

const TeamSlotV2: React.FC<TeamSlotV2Props> = ({ team, onPlayerAddClick, selectedPlayers = [] }) => {
    const selectedSteamIds = new Set(selectedPlayers.map(p => p.account.steamID));
    return (
        <div className={styles.teamSection}>
            <div className={styles.teamHeader}>
                <img src={team.imageURL} alt="Logo" className={styles.teamLogo} loading="lazy" />
                <span className={styles.teamName}>{team.name}</span>
            </div>
            <div className={styles.teamBody}>
                <div className={styles.playerGrid}>
                    {team.players.map((player, index) => {
                        if (!player.account || !player.account.steamID) {
                            console.error(`Error: Missing account or steamID for player at index ${index}: with more data ${player.teamId}`, player);
                            return null;
                        }
                        const alreadySelected = selectedSteamIds.has(player.account.steamID);
                        return (
                            <PlayerSlotV2
                                key={player.account.steamID}
                                player={player}
                                isSelected={alreadySelected}
                                onPlayerAddClick={onPlayerAddClick}
                            />
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default TeamSlotV2;
